var _defs, _image, _image2, _image3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 639,
    height: 331,
    viewBox: "0 0 639 331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 34px;\n        fill: #a5b0b6;\n        text-anchor: end;\n        font-family: \"Adobe Heiti Std\";\n      }\n    "))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "\\u76F4\\u7EBF_1",
    "data-name": "\\u76F4\\u7EBF 1",
    x: 91,
    y: 84,
    width: 194,
    height: 12,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAAAMCAYAAAAwA2L1AAAARElEQVRoge3TMRGAQAADwYB/G/RU2OOLyMiuhJu563m/PzDuXg8AMQKUEZgXI0AZgXkxApQRmBcjQBmBeTEClBGYlyQHiCEDIq7u1fUAAAAASUVORK5CYII="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "\\u76F4\\u7EBF_1-2",
    "data-name": "\\u76F4\\u7EBF 1",
    x: 92,
    y: 116,
    width: 143,
    height: 12,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI8AAAAMCAYAAABbR+7lAAAAPklEQVRYhe3SMREAIRDAwOP926Cnwt7jIfWuhEzWPvcfCD7RqMxDZh4y85CZh8w8ZOYhMw+ZecjMQ2Yempl5+m8DIp9i+egAAAAASUVORK5CYII="
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "\\u76F4\\u7EBF_1-3",
    "data-name": "\\u76F4\\u7EBF 1",
    x: 92,
    y: 149,
    width: 102,
    height: 12,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAMCAYAAACQsMheAAAAO0lEQVRYhe3RMQHAIBAAsaf+bbAzYa/YuCGxkLXP/YecT0mTmCgxUWKixESJiRITJSZKTJSYKDFFM/MAOEYDIszE59IAAAAASUVORK5CYII="
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "BANK_TRANSFER",
    "data-name": "BANK TRANSFER",
    className: "cls-1",
    transform: "matrix(2.8, 0, -0.733, 2.809, 544.821, 157.177)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "BANK"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: 40.8
  }, "TRANSFER"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank-transfer.0b0009ce13bdc533c41114016585e1c4.svg";
export { ForwardRef as ReactComponent };